import React from 'react';
import { IconButton } from 'src/domains/common/components/button/icon-button';
import { observer } from 'src/utils/mobx-react';

interface PaginationPropsType {
    currentPage: number;
    onPageChange: (page: number) => void;
    totalPages: number;
}

export const Pagination = observer(
    'Pagination',
    ({ currentPage, totalPages, onPageChange }: PaginationPropsType): JSX.Element => {
        return (
            <div className='flex items-center gap-2'>
                <span className='text-xs'>
                    Page <b className='font-semibold'>{currentPage}</b> of <b className='font-semibold'>{totalPages}</b>
                </span>

                <IconButton
                    disabled={currentPage === 1}
                    icon='chevrons-left'
                    onClick={() => onPageChange(1)}
                    size='sm'
                    variant='outline'
                />
                <IconButton
                    disabled={currentPage === 1}
                    icon='caret-left'
                    onClick={() => onPageChange(currentPage - 1)}
                    size='sm'
                    variant='outline'
                />
                <IconButton
                    disabled={currentPage === totalPages}
                    icon='caret-right'
                    onClick={() => onPageChange(currentPage + 1)}
                    size='sm'
                    variant='outline'
                />
                <IconButton
                    disabled={currentPage === totalPages}
                    icon='chevrons-right'
                    onClick={() => onPageChange(totalPages)}
                    size='sm'
                    variant='outline'
                />
            </div>
        );
    }
);
